import { useEffect, useState } from "react";
import FormField from "./FormField";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import Text from "./Text";
import { ProgressSpinner } from "primereact/progressspinner";
import { IVehicleBrand, useFindVehicleBrand } from "../hooks/useFindVehicleBrand";

export interface IVehicleBrandSearchSelectorProps {
    selectedVehicleBrand: { id: string; name: string; } | undefined;
    selectVehicleBrand: (brand: { id: string; name: string; code: string; } | undefined) => void;
    disabled?: boolean;
    hasError?: boolean;
    error?: string;
}

const VehicleBrandSearchSelector = (props: IVehicleBrandSearchSelectorProps) => {
    const { findVehicleBrandByName, loadingVehicles } = useFindVehicleBrand();
    const [searchBrandResult, setSearchBrandResult] = useState<IVehicleBrand[]>([]);
    const [vehicleBrandSearchText, setVehicleBrandSearchText] = useState("");

    useEffect(() => {
        const searchTimeout = setTimeout(async () => {
            setSearchBrandResult(await findVehicleBrandByName(vehicleBrandSearchText));
        }, 1000);

        return () => clearTimeout(searchTimeout);
    }, [vehicleBrandSearchText]);

    return (
        <FormField
            id="vehicleBrandSearchSelector"
            label="Procure pela marca"
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText
                    value={props.selectedVehicleBrand?.name ?? vehicleBrandSearchText}
                    className="w-full pr-5"
                    invalid={props.hasError}
                    disabled={props.disabled}
                    onChange={(e) => {
                        setVehicleBrandSearchText(e.target.value);
                    }}
                />

                {
                    !!props.selectedVehicleBrand?.name && <Icon
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.selectVehicleBrand(undefined);
                            setVehicleBrandSearchText("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                loadingVehicles && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>
                )
            }

            {
                !!searchBrandResult?.length && !props.selectedVehicleBrand?.name && vehicleBrandSearchText && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            searchBrandResult.map(v => {
                                return (
                                    <li key={v.id}>
                                        <a
                                            className="cursor-pointer"
                                            onClick={() => {
                                                props.selectVehicleBrand({ id: v.id, name: v.name, code: v.value });
                                            }}
                                        >
                                            {v.name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default VehicleBrandSearchSelector;
